import React from 'react'
import { Modal2PropsType } from '../type'
import { Template } from './template'
import ReactDOM from 'react-dom'

import './animations.css'
import { ProviderModel } from '../model/z-index'
import styled, { ThemeProvider } from 'styled-components'
import { AnyObject } from '@rst/libs-ts'

export const Modal2: React.FC<Modal2PropsType> = ({
	active,
	children,
	preventDefault,
	...props
}) => {
	return (
		<StyleModal
			onClick={e => {
				if (preventDefault) {
					e.preventDefault()
					e.stopPropagation()
				}
			}}
		>
			<ProviderModel>
				<Template
					{...props}
					preventDefault={preventDefault}
					active={active}
					showAnimation="downToTop"
				>
					{children}
				</Template>
			</ProviderModel>
		</StyleModal>
	)
}

const StyleModal = styled.div`
	.z-index {
		z-index: 1000;
	}
`

export interface Modal2ForwardPropsType extends Modal2PropsType {
	children:
		| JSX.Element
		| null
		| ((props: { handleClose: VoidFunction }) => JSX.Element | null)
	theme?: AnyObject
}

export const modal2Forward = async ({
	children,
	theme = {},
	...props
}: Modal2ForwardPropsType) => {
	const div = document.createElement('div')
	document.body.appendChild(div)

	await new Promise(resolve => {
		const close = () => {
			if (props?.close) props.close()
			resolve(null)
		}

		ReactDOM.render(
			<ThemeProvider theme={theme}>
				<Modal2
					{...props}
					active={true}
					close={close}
					onUnmount={() => {
						if (props?.onUnmount) props.onUnmount()
						resolve(null)
					}}
				>
					{typeof children === 'function'
						? children({ handleClose: close })
						: children}
				</Modal2>
			</ThemeProvider>,
			div
		)
	})
	ReactDOM.unmountComponentAtNode(div)
	div.remove()
}
